import Alpine from "alpinejs";

// Shopify WebMCP (https://shopify.dev/docs/api/web-mcp)
// AI 에이전트가 카트 도구(add_to_cart, update_cart_lines, cancel_cart)를 부르면 Shopify 가 Shopify.actions.updateCart 를 실행한다.
// 이 테마는 장바구니를 Alpine 스토어($store.cart)와 .cart-badge 로 그리는데, 기본 동작은 이 화면을 모른다.
// 설정하지 않으면 기본값이 "페이지 전체 새로고침"이라 에이전트의 도구 호출 결과가 끊길 수 있어서(페이지가 이동하면 null),
// 새로고침 대신 스토어와 배지만 다시 읽어 온다. (configure 는 첫 호출만 적용된다)
const refreshThemeCart = async () => {
  try {
    await Alpine.store("cart").getCart();

    const response = await fetch(`${window.Shopify.routes.root}?sections=cart-badge`);
    const sections = await response.json();

    if (sections?.["cart-badge"]) {
      document.querySelectorAll(".cart-badge").forEach((badge) => {
        badge.innerHTML = sections["cart-badge"];
      });
    }
  } catch (error) {
    console.log("[webmcp] cart refresh failed", error);
  }
};

// Shopify.actions 는 Shopify 스크립트가 늦게 붙일 수 있어서(DOMContentLoaded 이후일 수 있다) 준비될 때까지 잠깐 기다린다
const WAIT_INTERVAL_MS = 100;
const WAIT_MAX_TRIES = 100;

const configureActions = (tries = 0) => {
  const updateCart = window.Shopify?.actions?.updateCart;

  if (!updateCart?.configure) {
    if (tries < WAIT_MAX_TRIES) setTimeout(() => configureActions(tries + 1), WAIT_INTERVAL_MS);
    return;
  }

  updateCart.configure({
    // 이 테마는 shopify:cart:* 이벤트를 듣지 않으므로 기본(document)에서 보낸다
    eventTarget: () => null,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      await refreshThemeCart();
      return result;
    },
  });
};

export const initWebMcp = () => {
  configureActions();
};
